// Intent: [Journey] [Trust]
import React from "react";
import { AUSTEN_EMAIL } from "../config";
import { ButtonLink } from "../components/shared/ButtonLink";
import { CutPlan } from "../components/shared/CutPlan";
function NotFoundPage() {
  return <main id="main-content" className="relative grid min-h-[62vh] place-items-center overflow-hidden bg-pfpc-offwhite py-16" data-id="element-642" data-mp="2xtii47sbhc0v">
      <CutPlan className="absolute inset-0 h-full w-full opacity-45" data-id="element-643" data-mp="2szxkigumyk27" />
      <div className="container-shell relative" data-id="element-644" data-mp="36s4309l9h34t">
        <div className="max-w-2xl border border-pfpc-navy/15 bg-pfpc-offwhite p-7 md:p-12" data-id="element-645" data-mp="31ukmf313ce9p">
          <p className="section-label text-pfpc-orange" data-id="element-646" data-mp="3grl22860cirt">Page not found · 404</p>
          <h1 className="mt-4 font-heading text-[38px] font-extrabold leading-[1.08] text-pfpc-navy md:text-[52px]" data-id="element-647" data-mp="3gpidztof0zpq">
            This path is not part of the current site.
          </h1>
          <p className="mt-5 max-w-xl text-[17px] leading-7 text-pfpc-navy/70" data-id="element-648" data-mp="1mdtynqe9uv4t">
            Return to the homepage, or email Austen if you were looking for ordering information that is not listed yet.
          </p>
          <div className="mt-8 flex flex-col items-start gap-3 sm:flex-row sm:flex-wrap" data-id="element-649" data-mp="w9w88byx1i23">
            <ButtonLink href="/" data-id="element-650" data-mp="10bhp08ekmghk">Return to homepage</ButtonLink>
            <ButtonLink href={`mailto:${AUSTEN_EMAIL}`} variant="secondary" data-id="element-651" data-mp="15bm5hyfhbb7s">Email Austen</ButtonLink>
          </div>
        </div>
      </div>
    </main>;
}
export { NotFoundPage };